import AdminUpdatePasein from "../../components/AdminPurchaseOrder/AdminPurchaseOrderUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
